import tw, { styled } from "twin.macro";

export default styled.button`
  ${tw`underline text-gray-400`}
  ${tw`hover:text-gray-500 active:text-gray-600`}
  ${tw`disabled:cursor-not-allowed focus:outline-none`}
`;
